import { createAction } from '@reduxjs/toolkit';
import { promoStoreCouponsSlice } from './reducer';

export const fetchPromoStoreCoupons = createAction('promoStoreCoupons/fetchPromoStoreCoupons');

export const { clearPromoStoreCoupons, setPromoStoreCoupons, setIsFetching } = promoStoreCouponsSlice.actions;
